import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "locale", "name", "image", "children"],
    _excluded2 = ["className", "children", "count"],
    _excluded3 = ["className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext, useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Comments.styles';
import FormatDateTime from '../FormatDateTime';
import Collapsible from '../Collapsible';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CommentsContext = createContext();
var Comments = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      mode = _ref.mode,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-GB' : _ref$locale,
      name = _ref.name,
      image = _ref.image,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var context = {
    name: name,
    image: image,
    locale: locale
  };
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-comments"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(CommentsContext.Provider, {
      value: context,
      children: _jsx(Styled.Comments, _objectSpread(_objectSpread({
        ref: ref,
        className: className
      }, rest), {}, {
        children: children
      }))
    })
  });
});
var CommentsComment = forwardRef(function (_ref2, ref) {
  var _cx2;

  var customClassName = _ref2.className,
      children = _ref2.children,
      name = _ref2.name,
      timestamp = _ref2.timestamp,
      subject = _ref2.subject,
      _ref2$hasWeekday = _ref2.hasWeekday,
      hasWeekday = _ref2$hasWeekday === void 0 ? false : _ref2$hasWeekday,
      _ref2$isRelative = _ref2.isRelative,
      isRelative = _ref2$isRelative === void 0 ? false : _ref2$isRelative,
      image = _ref2.image,
      message = _ref2.message,
      actions = _ref2.actions;
  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-comments__comment"), true), _defineProperty(_cx2, customClassName, !!customClassName), _cx2));

  var _useContext = useContext(CommentsContext),
      locale = _useContext.locale;

  return _jsxs(Styled.CommentsComment, {
    className: className,
    children: [_jsx(Styled.CommentsAvatar, {
      name: name,
      src: image
    }), _jsxs(Styled.CommentsInfo, {
      children: [_jsxs(Styled.CommentsMetadata, {
        children: [_jsx(Styled.CommentsMetadataText, {
          isSemibold: true,
          children: name
        }), subject && _jsxs(Styled.CommentsMetadataText, {
          isSecondary: true,
          children: [' ', subject]
        })]
      }), timestamp && _jsx(Styled.CommentsMetadataDate, {
        children: _jsx(FormatDateTime, {
          hasWeekday: hasWeekday,
          value: timestamp,
          locale: locale,
          isRelative: isRelative
        })
      }), actions && _jsx(Styled.CommentsActions, {
        children: actions
      })]
    }), _jsxs(Styled.CommentsCommentContent, {
      children: [message && _jsx(Styled.CommentsCommentMessage, {
        children: message
      }), children]
    })]
  });
});
var CommentsLoadPrevious = forwardRef(function (_ref3, ref) {
  var _cx3;

  var customClassName = _ref3.className,
      _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? 'Load previous replies' : _ref3$children,
      count = _ref3.count,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var className = cx((_cx3 = {}, _defineProperty(_cx3, "".concat(prefix, "-comments__load-previous"), true), _defineProperty(_cx3, customClassName, !!customClassName), _cx3));
  return _jsxs(Styled.CommentsLoadPrevious, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    children: [children, " ", count && "(".concat(count, ")")]
  }));
});
var CommentsReply = forwardRef(function (_ref4, ref) {
  var _cx4;

  var customClassName = _ref4.className,
      _ref4$children = _ref4.children,
      children = _ref4$children === void 0 ? 'Reply' : _ref4$children,
      rest = _objectWithoutProperties(_ref4, _excluded3);

  var className = cx((_cx4 = {}, _defineProperty(_cx4, "".concat(prefix, "-comments__reply"), true), _defineProperty(_cx4, customClassName, !!customClassName), _cx4));
  return _jsx(Styled.CommentsReply, _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    children: children
  }));
});
var CommentsForm = forwardRef(function (_ref5, ref) {
  var _cx5;

  var customClassName = _ref5.className,
      _ref5$isOpen = _ref5.isOpen,
      isOpen = _ref5$isOpen === void 0 ? true : _ref5$isOpen,
      _ref5$type = _ref5.type,
      type = _ref5$type === void 0 ? "reply" : _ref5$type,
      children = _ref5.children;
  var className = cx((_cx5 = {}, _defineProperty(_cx5, "".concat(prefix, "-comments__form"), true), _defineProperty(_cx5, "".concat(prefix, "-comments__form--visible"), isOpen), _defineProperty(_cx5, "".concat(prefix, "-comments__form--").concat(type), true), _defineProperty(_cx5, customClassName, !!customClassName), _cx5));

  var _useContext2 = useContext(CommentsContext),
      name = _useContext2.name,
      image = _useContext2.image;

  return _jsx(Styled.CommentsForm, {
    className: className,
    children: _jsx(Collapsible, {
      isOpen: isOpen,
      children: _jsxs(Styled.CommentsFormContainer, {
        children: [_jsx(Styled.CommentsAvatar, {
          name: name,
          src: image
        }), _jsx(Styled.CommentsCommentContent, {
          children: children
        })]
      })
    })
  });
});
Comments.displayName = 'Comments';
Comments.Comment = CommentsComment;
Comments.LoadPrevious = CommentsLoadPrevious;
Comments.Reply = CommentsReply;
Comments.Form = CommentsForm;
Comments.FormContent = Styled.CommentsFormContent;
Comments.FormActions = Styled.CommentsFormActions;
export default Comments;